module.exports = __webpack_public_path__ + "img/appAsset--branch-ax.3d961035.svg";